"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var Link_1 = require("shared/components/Link");
var general_1 = require("utils/general");
var MentionAvatar_1 = __importDefault(require("./MentionAvatar"));
var MentionLabel = (0, styles_1.styled)(material_1.Box, { shouldForwardProp: (0, general_1.omitProps)('labelType') })(function (_a) {
    var labelType = _a.labelType, theme = _a.theme;
    return ({
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'bottom',
        borderRadius: 2,
        color: labelType === 'services' ? theme.palette.text.secondary : theme.palette.secondary.main,
        cursor: labelType === 'services' ? 'pointer' : 'default',
        fontWeight: labelType === 'services' ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular,
        textDecoration: 'none',
        fontSize: theme.typography.body2.fontSize,
        opacity: 1,
        ':hover': __assign(__assign({}, (labelType === 'services' && { color: theme.palette.text.primary })), { textDecoration: 'none', opacity: 1 }),
    });
});
var MentionLink = function (_a) {
    var mention = _a.mention;
    return ((0, jsx_runtime_1.jsx)(Link_1.LinkIfTo, __assign({ to: mention.link || '' }, { children: (0, jsx_runtime_1.jsxs)(MentionLabel, __assign({ labelType: mention.collection }, { children: [(0, jsx_runtime_1.jsx)(MentionAvatar_1.default, { mention: mention, hasNoAvatar: true }), mention.name] })) })));
};
exports.default = MentionLink;
